// Angular
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, OnChanges } from '@angular/core';
import {
	NavigationCancel,
	NavigationEnd,
	NavigationStart,
	RouteConfigLoadEnd,
	RouteConfigLoadStart,
	Router
} from '@angular/router';
// Object-Path
import * as objectPath from 'object-path';
// Loading bar
import { LoadingBarService } from '@ngx-loading-bar/core';
// Layout
import { LayoutConfigService, LayoutRefService } from '../../../core/_base/layout';
// HTML Class Service
import { HtmlClassService } from '../html-class.service';
import { ApiService } from 'src/app/Services/api.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { OtherApiService } from 'src/app/Services/other.service';


@Component({
	selector: 'kt-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnChanges {
	// Public properties
	menuHeaderDisplay: boolean;
	fluid: boolean;
	entityName : any;
	colourTheme : any;
	@ViewChild('ktHeader', {static: true}) ktHeader: ElementRef;
	session: string;
	userType: string;
	sessions: any;
	entityId = localStorage.getItem('entityId');
	entity :any= JSON.parse(localStorage.getItem('entityData'));
	userPreferences = JSON.parse(localStorage.getItem('userPreferences'));
	userMobile = localStorage.getItem('mobile')
	userName = localStorage.getItem('name')
	contactEmail = localStorage.getItem('contactEmail');
	selectedSession: any= {};
	browserDomain: string;
	selectedEntity: any;
	entityGroup: any;
	buttonTheme: HTMLCollectionOf<Element>;
	btnLenght: number;
	showMessage: boolean;
	// sessionData: import("c:/Users/Navafood/Desktop/OkieDokie/od-erp-angular/src/app/Services/data.model").UserData[];

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param layoutRefService: LayoutRefService
	 * @param layoutConfigService: LayoutConfigService
	 * @param loader: LoadingBarService
	 * @param htmlClassService: HtmlClassService
	 */
	constructor(
		private router: Router,
		private layoutRefService: LayoutRefService,
		private layoutConfigService: LayoutConfigService,
		public loader: LoadingBarService,
		public htmlClassService: HtmlClassService,
		private service : OtherApiService,
		private util : UtilsService,
		private ref : ChangeDetectorRef
	) {
		// page progress bar percentage
		this.router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				// set page progress bar loading to start on NavigationStart event router
				this.loader.start();
			}
			if (event instanceof RouteConfigLoadStart) {
				this.loader.increment(35);
			}
			if (event instanceof RouteConfigLoadEnd) {
				this.loader.increment(75);
			}
			if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
				// set page progress bar loading to end on NavigationEnd event router
				this.loader.complete();
			}
		});
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		if(this.userPreferences && this.userPreferences.entityDisplayName){
			this.entityName = this.userPreferences.entityDisplayName
		}else{
			this.entityName = localStorage.getItem('entityName')
		}
		// if(this.entity && this.entity.paymentDueMessage){
		// 	this.showMessage = true;
		// }else{
		// 	this.showMessage = false;
		// }
		const config = this.layoutConfigService.getConfig();
		this.session = this.htmlClassService.getSessionName();	
		this.menuHeaderDisplay = objectPath.get(config, 'header.menu.self.display');
		this.fluid = objectPath.get(config, 'header.self.width') === 'fluid';
		if (objectPath.get(config, 'header.self.fixed.desktop.enabled') || objectPath.get(config, 'header.self.fixed.desktop')) {
			this.ktHeader.nativeElement.setAttribute('data-ktheader-minimize', '1');
		}
		this.ref.detectChanges()
	}
	ngOnChanges(): void {
		//this.session = localStorage.getItem('session');
		this.session = this.htmlClassService.getSessionName();
	}
	ngAfterViewInit(): void {
		// keep header element in the service
		this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
	}
	
	changeEntitySelected(event){
		this.selectedEntity = event;
		this.service.getEntityData(this.selectedEntity)
		.subscribe(res=>{
		localStorage.removeItem('sessionEndDate');
		localStorage.removeItem('sessionStartDate');
		localStorage.removeItem('session');
		localStorage.removeItem('entityType');
		localStorage.removeItem('entityId');
		localStorage.removeItem('logo')
		localStorage.removeItem('entityName')
		localStorage.removeItem('primaryColour')
		localStorage.removeItem('secondaryColour')
		localStorage.removeItem('entityPreferences')
		localStorage.removeItem('courseByTeacherData')
        localStorage.removeItem('courseByTeacherDataDateWise');

		localStorage.setItem('entityId', res._id);
         
          localStorage.setItem('logo', res.logo);
          localStorage.setItem('entityPreferences', JSON.stringify(res.entityPreferences))
          if(res.entityPreferences && res.entityPreferences.colourTheme){
            
          localStorage.setItem('secondaryColour', res.entityPreferences.colourTheme);
          localStorage.setItem('primaryColour', res.entityPreferences.colourTheme);

          if(res.entityPreferences.colourTheme == '#ffffff'){
            localStorage.setItem('primaryColour', '#1ca9c9');
          }
          }
          localStorage.setItem('entityName', res.displayName)
          localStorage.setItem('entityType', res.entityType)
          if(!res.activeSession){
            this.util.alertNotificationMessage('Please Activate A Session First');
		  window.location.href = this.browserDomain + '/academicSession';
		  return
          }else{
          localStorage.setItem('session', res.activeSession.name);
          localStorage.setItem('sessionStartDate', res.activeSession.startDate);
          localStorage.setItem('sessionEndDate', res.activeSession.endDate);
		  }
		  this.ref.detectChanges();
		//   window.location.reload();
          window.location.href = this.browserDomain + '/entityDashboard';
		
		},
		err=>{
		})
	}
	listSession(){
		this.service.getSessionList(this.entityId)
		.subscribe(data => {
			 this.sessions = data;
		  },
		  err=>{
			this.util.errmsg(err);
		  });
	}
	compareObjects(o1: any, o2: any): boolean {
	return o1.name === o2.name;
	}

	activateSession(event){
	this.selectedSession = event;

	localStorage.removeItem('session');
		localStorage.removeItem('sessionStartDate');
		localStorage.removeItem('sessionEndDate');
		localStorage.setItem('session', this.selectedSession.name);
		localStorage.setItem('sessionStartDate', this.selectedSession.startDate);
		localStorage.setItem('sessionEndDate', this.selectedSession.endDate);
		this.util.alertMessage('Session ', 'changed to '+this.selectedSession.name)
	//   window.location.reload();
		this.util.redirect('entityDashboard')
	}
	createTicket(){
		window.open( 'https://data.odpay.in/odforms1/form/BugTracker/formperma/nXRLFMBDgeyMadv0uD7-AFRLrx6zhw9q59yh1ToH_N4?entityName='+this.entityName+'&userName='+this.userName+'&userMobile='+this.userMobile +'&contactEmail='+this.contactEmail,  "_blank");
   }
	redirect(route){
	this.util.redirect(route);
	}
}
